import React, { useEffect, useState } from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { Menu, Dropdown } from "antd";
import { BsThreeDotsVertical } from "react-icons/bs";

import { ClipLoader } from "react-spinners";
import {
  Button,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Table,
  message,
  Popconfirm,
  Upload,
} from "antd";
import {
  createVehicle,
  deleteVehicle,
  deleteAllVehicles,
  getAvailableVehicles,
  getVehicles,
  updateVehicle,
  createBulkVehicles,
} from "../../../API/Admin/vehicles";
import { useParams } from "react-router-dom";
import {
  UploadOutlined,
  DownloadOutlined,
  ArrowLeftOutlined,
  CheckCircleTwoTone,
  CloseCircleTwoTone,
} from "@ant-design/icons";
import file from "../../../Assets/Template Files/VehicleData.xlsx";
import * as XLSX from "xlsx";

const { Option } = Select;

const battery_voltage_list = [
  {
    id: 1,
    value: "12V",
  },
  {
    id: 2,
    value: "24V",
  },
  {
    id: 3,
    value: "48V",
  },
];

const Vehicles = () => {
  const { userId } = useParams();
  const [loading, setLoading] = useState(false);
  const [isVehicleModalVisible, setIsVehicleModalVisible] = useState(false);
  const [vehiclesData, setVehiclesData] = useState([]);
  const [vehiclesList, setVehiclesList] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [form] = Form.useForm();
  const [importModalVisible, setImportModalVisible] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [importLoading, setImportLoading] = useState(false);
  const navigate = useNavigate();
  const fetchAvailableVehicleData = async () => {
    try {
      setLoading(true);
      const response = await getAvailableVehicles(userId);
      setVehiclesList(response?.data);
      setLoading(false);
    } catch (error) {
      message.error("Failed to fetch vehicle data");
      console.log(error, "Failed to fetch vehicle data");
    }
    setLoading(false);
  };

  const fetchVehicleData = async () => {
    try {
      setLoading(true);
      const response = await getVehicles(userId);
      setVehiclesData(response?.data);
      setLoading(false);
    } catch (error) {
      message.error("Failed to fetch vehicle data");
      console.log(error, "Failed to fetch vehicle data");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchVehicleData();
    fetchAvailableVehicleData();
  }, []);

  const handleVehicleModalClose = () => {
    setIsVehicleModalVisible(false);
    form.resetFields();
    setEditingId(null);
  };

  const handleOpenModal = async (vehicle = null) => {
    await fetchAvailableVehicleData();
    if (vehicle) {
      setEditingId(vehicle.id);
      form.setFieldsValue({
        vehicle: vehicle.vehicle_name,
        num_cylinders: vehicle.num_cylinders,
        tank_capacity: vehicle.tank_capacity,
        fuel_cylinder_hr: vehicle.fuel_cylinder_hr,
        fuel_utilization: vehicle.fuel_utilization,
        has_fuel_sensor: vehicle.has_fuel_sensor ? "1" : "0",
        fuel_type: vehicle.fuel_type,
        vehicle_type: vehicle.vehicle_type,
        fuel_calculation_method: vehicle.fuel_calculation_method,
        battery_voltage: vehicle.battery_voltage,
      });
    }
    setIsVehicleModalVisible(true);
  };

  const handleFinishVehicle = async (values) => {
    try {
      setLoading(true);
      if (editingId) {
        const { vehicle, ...payload } = values;
        const response = await updateVehicle(editingId, payload);
        if (response?.data) {
          message.success(
            response.data.message || "Vehicle updated successfully"
          );
          fetchVehicleData();
        }
      } else {
        console.log(values);
        const response = await createVehicle({ ...values, user_id: userId });
        if (response?.data) {
          message.success(
            response.data.message || "Vehicle created successfully"
          );
          setVehiclesData((v) => v.concat(response.data.data));
        }
      }
    } catch (error) {
      message.error(error.response?.data?.message || "Operation failed");
      console.log(error, "Operation failed");
    } finally {
      setLoading(false);
      handleVehicleModalClose();
    }
  };

  const handleDeleteVehicle = async (vehicleId) => {
    try {
      setLoading(true);
      await deleteVehicle(vehicleId);
      setVehiclesData((prevData) =>
        prevData.filter((vehicle) => vehicle.id !== vehicleId)
      );
      message.success("Vehicle deleted successfully!");
    } catch (error) {
      message.error("Failed to delete vehicle");
      console.log(error, "Failed to delete vehicle");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAllVehicles = async () => {
    try {
      setLoading(true);
      await deleteAllVehicles(userId);
      setVehiclesData([]);
      message.success("Vehicles deleted successfully!");
    } catch (error) {
      message.error("Failed to delete vehicles");
      console.log(error, "Failed to delete vehicles");
    } finally {
      setLoading(false);
    }
  };

  const handleImportModalClose = () => {
    setImportModalVisible(false);
    setFileList([]);
  };

  const beforeUpload = (file) => {
    const isExcel =
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.ms-excel";
    if (!isExcel) {
      message.error("You can only upload Excel files!");
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const handleFileChange = ({ fileList }) => {
    setFileList(fileList);
  };

  const parseExcelData = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          let jsonData = XLSX.utils.sheet_to_json(firstSheet);

          jsonData = jsonData.map((row) => {
            const cleanedRow = {};
            for (const key in row) {
              const cleanKey = key.trim().toLowerCase().replace(/\s+/g, "_");
              const value = row[key];
              cleanedRow[cleanKey] =
                typeof value === "string" ? value.trim() : value;
            }
            return cleanedRow;
          });

          resolve(jsonData);
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });
  };

  const validateVehicleData = (data) => {
    const requiredFields = [
      "vehicle",
      "vehicle_type",
      "num_cylinders",
      "tank_capacity",
      "fuel_cylinder_hr",
      "fuel_utilization",
      "fuel_type",
      "fuel_calculation_method",
      "vehicle_name",
      "has_fuel_sensor",
      "battery_voltage",
    ];

    return data.map((item, index) => {
      const errors = [];
      requiredFields.forEach((field) => {
        if (!item[field] && item[field] !== 0) {
          errors.push(`Missing ${field}`);
        }
      });

      if (
        item.vehicle_type &&
        !["REGULAR", "STATIONARY"].includes(item.vehicle_type)
      ) {
        errors.push("Invalid vehicle_type (must be REGULAR or STATIONARY)");
      }

      if (
        item.fuel_type &&
        ![
          "regular_diesel",
          "low_sulphur_diesel",
          "regular_fuel",
          "premium_fuel",
        ].includes(item.fuel_type)
      ) {
        errors.push("Invalid fuel_type");
      }

      if (
        item.fuel_calculation_method &&
        !["KM_L", "L_HR"].includes(item.fuel_calculation_method)
      ) {
        errors.push("Invalid fuel_calculation_method (must be KM_L or L_HR)");
      }

      return {
        ...item,
        index,
        errors,
      };
    });
  };

  const handleImportSubmit = async () => {
    if (fileList.length === 0) {
      message.error("Please upload an Excel file first");
      return;
    }

    try {
      setImportLoading(true);
      const file = fileList[0].originFileObj;
      const jsonData = await parseExcelData(file);

      console.log(jsonData);

      const validatedData = validateVehicleData(jsonData);

      // console.log(validatedData);

      const vehiclesWithErrors = validatedData.filter(
        (item) => item.errors.length > 0
      );

      console.log(vehiclesWithErrors);

      if (vehiclesWithErrors.length > 0) {
        const errorMessages = vehiclesWithErrors
          .map((item) => `Row ${item.index + 2}: ${item.errors.join(", ")}`)
          .join("\n");
        message.error(`Some rows have errors:\n${errorMessages}`);
        return;
      }

      const cleanData = validatedData.map(({ index, errors, ...rest }) => rest);
      const response = await createBulkVehicles(cleanData, userId);

      if (response?.data) {
        message.success(`Successfully imported ${cleanData.length} vehicles`);
        fetchVehicleData();
        handleImportModalClose();
      }
    } catch (error) {
      message.error(
        error.response?.data?.message || "Failed to import vehicles"
      );
      console.error("Import error:", error);
    } finally {
      setImportLoading(false);
    }
  };

  const handleDownloadTemplate = async () => {
    const response = await fetch(file);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "vehicle_template.xlsx"; // <- desired filename
    document.body.appendChild(link);
    link.click();

    // Cleanup
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const columns = [
    {
      title: "Vehicle",
      dataIndex: "vehicle",
      key: "vehicle",
      width: "15%",
    },
    {
      title: "Vehicle Name",
      dataIndex: "vehicle_name",
      key: "vehicleName",
      width: "15%",
    },
    {
      title: "Type",
      dataIndex: "vehicle_type",
      key: "type",
      render: (text) => (text === "STATIONARY" ? "Stationary" : "Regular"),
      width: "10%",
    },
    {
      title: "Cylinders",
      dataIndex: "num_cylinders",
      key: "cylinders",
      width: "10%",
    },
    {
      title: "Tank Capacity",
      dataIndex: "tank_capacity",
      key: "tank_capacity",
      width: "12%",
    },
    {
      title: "Idle User/Hr",
      dataIndex: "fuel_cylinder_hr",
      key: "fuelPerCylinder",
      width: "12%",
    },
    {
      title: "Fuel Utilization",
      dataIndex: "fuel_utilization",
      key: "fuelUtilization",
      render: (text, record) => (
        <span>
          {text} {record.fuel_calculation_method === "L_HR" ? "L/Hr" : "Km/L"}
        </span>
      ),
      width: "15%",
    },
    {
      title: "Fuel Type",
      dataIndex: "fuel_type",
      key: "fuelType",
      render: (text) => {
        const fuelTypes = {
          regular_diesel: "Diesel",
          low_sulphur_diesel: "Low Sulphur",
          regular_fuel: "Regular",
          premium_fuel: "Premium",
        };
        return fuelTypes[text] || text;
      },
      width: "13%",
    },
    {
      title: "Battery Voltage",
      dataIndex: "battery_voltage",
      key: "batteryVoltage",
      width: "15%",
    },
    {
      title: "Fuel Sensor",
      dataIndex: "has_fuel_sensor",
      key: "hasFuelSensor",
      render: (value) =>
        value ? (
          <CheckCircleTwoTone twoToneColor="#52c41a" />
        ) : (
          <CloseCircleTwoTone twoToneColor="#ff4d4f" />
        ),
      width: "15%",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => {
        const menu = (
          <Menu className="fuel-station-dropdown-menu">
            <Menu.Item key="edit" onClick={() => handleOpenModal(record)}>
              <span className="actions-item-spc">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.11526 8.03609L10.0308 8.95159L15.6578 3.32459L14.7423 2.40909L9.11526 8.03609ZM2.06726 15.9996H2.98276L8.95201 10.0303L8.03651 9.11484L2.06726 15.0841V15.9996ZM10.5578 10.5573L7.51926 7.50934L12.002 3.02659L11.4598 2.48434C11.4084 2.433 11.3315 2.40734 11.229 2.40734C11.1263 2.40734 11.0493 2.433 10.998 2.48434L5.82126 7.66109L4.76751 6.62659L9.94826 1.43034C10.3098 1.06884 10.7373 0.888086 11.2308 0.888086C11.7244 0.888086 12.152 1.06884 12.5135 1.43034L13.0558 1.97259L14.0943 0.934337C14.2751 0.753504 14.4885 0.663086 14.7345 0.663086C14.9807 0.663086 15.1942 0.753504 15.375 0.934337L17.171 2.73034C17.3518 2.91117 17.4391 3.11825 17.4328 3.35159C17.4263 3.58492 17.3327 3.79192 17.152 3.97259L10.5578 10.5573ZM3.60576 17.4996H0.567261V14.4611L7.50976 7.50934L10.5578 10.5573L3.60576 17.4996Z"
                    fill="#DEDEDE"
                  />
                </svg>
                Edit
              </span>
            </Menu.Item>

            <Menu.Item
              key="delete"
              onClick={() => handleDeleteVehicle(record.id)}
            >
              <span className="actions-item-spc">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.22363 0.00257456C9.7312 -0.0236624 10.2294 0.151464 10.6084 0.489879C10.9872 0.828222 11.217 1.3024 11.248 1.80922V3.00062C11.2488 3.05484 11.2403 3.10855 11.2266 3.16078H11.874C11.8999 3.15763 11.9258 3.15297 11.9521 3.15297C11.9785 3.15297 12.0044 3.15761 12.0303 3.16078H13.4004C13.5594 3.16088 13.7118 3.22419 13.8242 3.33656C13.9367 3.44899 14 3.60139 14 3.76039C14 3.91937 13.9366 4.07176 13.8242 4.18422C13.7118 4.29659 13.5594 4.35989 13.4004 4.36H12.5996V12.1881C12.5854 12.4417 12.5211 12.6901 12.4102 12.9186C12.2993 13.1469 12.1444 13.3512 11.9541 13.5192C11.7636 13.6873 11.5414 13.8164 11.3008 13.8981C11.0602 13.9798 10.8053 14.0131 10.5518 13.9957H3.44824C3.19472 14.0131 2.93983 13.9798 2.69922 13.8981C2.45865 13.8164 2.23637 13.6872 2.0459 13.5192C1.85558 13.3512 1.70072 13.1469 1.58984 12.9186C1.4789 12.6901 1.41462 12.4417 1.40039 12.1881V4.36H0.599609C0.520949 4.35995 0.442792 4.34419 0.370117 4.3141C0.297477 4.28396 0.231396 4.2398 0.175781 4.18422C0.120136 4.12856 0.0760245 4.06257 0.0458984 3.98988C0.0157522 3.91713 0 3.83913 0 3.76039C1.57001e-05 3.68167 0.0157609 3.60362 0.0458984 3.53089C0.0760444 3.45822 0.120126 3.39219 0.175781 3.33656C0.231417 3.28095 0.297444 3.23681 0.370117 3.20668C0.442792 3.17659 0.520949 3.16083 0.599609 3.16078H2.80078C2.78634 3.1089 2.77637 3.05542 2.77637 3.00062V1.80922C2.8074 1.30673 3.03364 0.836342 3.40723 0.498668C3.78103 0.160919 4.27285 -0.0171864 4.77637 0.00257456H9.22363ZM2.59961 12.1881C2.59961 12.516 2.97639 12.7955 3.40039 12.7955H10.5039C10.9519 12.7955 11.3037 12.516 11.3037 12.1881V4.36H2.59961V12.1881ZM5.57617 6.17543C5.73506 6.17555 5.88764 6.23885 6 6.35121C6.1123 6.46365 6.17578 6.61611 6.17578 6.77504V10.3893C6.17682 10.4686 6.16142 10.5472 6.13184 10.6207C6.10223 10.6943 6.05856 10.7615 6.00293 10.818C5.94714 10.8745 5.87993 10.9202 5.80664 10.9508C5.73364 10.9813 5.65527 10.9967 5.57617 10.9967C5.41787 10.9946 5.2663 10.9309 5.1543 10.819C5.04228 10.707 4.97766 10.5555 4.97559 10.3971V6.77504C4.97559 6.61612 5.03908 6.46364 5.15137 6.35121C5.26383 6.23874 5.41712 6.17543 5.57617 6.17543ZM8.42383 6.17543C8.58284 6.17545 8.73521 6.23876 8.84766 6.35121C8.96007 6.46367 9.02344 6.61602 9.02344 6.77504V10.3893C9.02341 10.549 8.96073 10.7024 8.84863 10.8161C8.73641 10.9298 8.58357 10.9946 8.42383 10.9967C8.26479 10.9967 8.11246 10.9334 8 10.8209C7.88753 10.7085 7.82422 10.5562 7.82422 10.3971V6.77504C7.82422 6.61599 7.88753 6.46367 8 6.35121C8.11246 6.23875 8.26479 6.17543 8.42383 6.17543ZM4.77637 1.20179C4.33648 1.20179 3.97577 1.48149 3.97559 1.80922V3.00062C3.97559 3.05534 3.96655 3.10897 3.95215 3.16078H10.0713C10.0573 3.10847 10.0471 3.055 10.0479 3.00062V1.80922C10.0477 1.48149 9.66393 1.2018 9.24805 1.20179H4.77637Z"
                    fill="#FB3748"
                  />
                </svg>
                Delete
              </span>
            </Menu.Item>
          </Menu>
        );

        return (
          <Dropdown overlay={menu} trigger={["click"]}>
            <Button
              type="text"
              icon={<BsThreeDotsVertical size={18} color="#8B899F" />}
              style={{ padding: 0 }}
            />
          </Dropdown>
        );
      },
    },
  ];

  if (loading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        className="loader-container"
      >
        <ClipLoader size={50} color={"#123abc"} loading={loading} />
      </div>
    );
  }

  return (
    <div className="vehicles-admin">
      <div className="page-header">
        <div className="page-title">
          <div className="title">
            <ArrowLeftOutlined
              style={{ marginRight: 12, cursor: "pointer" }}
              onClick={() => navigate("/general")}
            />
            Vehicle Data Entry
          </div>
          <div className="title-description">
            {new Date().toLocaleDateString("en-US", {
              weekday: "long",
              month: "short",
              day: "numeric",
              year: "numeric",
            })}
          </div>
        </div>
        <div className="button-group">
          <Button
            className="import-btn"
            onClick={() => handleDeleteAllVehicles()}
          >
            Delete All Vehicles
          </Button>
          <Button className="add-data-btn" onClick={() => handleOpenModal()}>
            Add Vehicle
          </Button>
          <Button
            className="import-btn"
            onClick={() => setImportModalVisible(true)}
          >
            Import from Excel
          </Button>
        </div>
      </div>

      <Table
        className="vehicles-table"
        columns={columns}
        dataSource={vehiclesData}
        rowKey="id"
        pagination={{ pageSize: 10 }}
        scroll={{ x: "max-content" }}
      />

      <Modal
        className="vehicle-modal"
        title={editingId ? "Edit Vehicle" : "Add Vehicle"}
        visible={isVehicleModalVisible}
        onCancel={handleVehicleModalClose}
        okText={editingId ? "Save Changes" : "Add Vehicle"}
        onOk={() => form.submit()}
        cancelText="Cancel"
      >
        <Form form={form} layout="vertical" onFinish={handleFinishVehicle}>
          <Form.Item
            label="Vehicle List"
            name="vehicle"
            rules={[{ required: true, message: "Please select a vehicle!" }]}
          >
            <Select placeholder="Select a vehicle" disabled={!!editingId}>
              {vehiclesList.map((vehicle) => (
                <Option key={vehicle.value} value={vehicle.value}>
                  {vehicle.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Vehicle Type"
            name="vehicle_type"
            rules={[{ required: true, message: "Please select vehicle type!" }]}
          >
            <Radio.Group>
              <Radio value="REGULAR">Regular Vehicle</Radio>
              <Radio value="STATIONARY">Stationary Equipment</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="Fuel Calculation Method"
            name="fuel_calculation_method"
            rules={[
              { required: true, message: "Please select calculation method!" },
            ]}
          >
            <Radio.Group>
              <Radio value="KM_L">Km per Liter (Km/L)</Radio>
              <Radio value="L_HR">Liters per Hour (L/Hr)</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="Fuel Sensor"
            name="has_fuel_sensor"
            rules={[
              { required: true, message: "Please select calculation method!" },
            ]}
          >
            <Radio.Group>
              <Radio value="1">Available</Radio>
              <Radio value="0">Not Available</Radio>
            </Radio.Group>
          </Form.Item>

          <div style={{ display: "flex", gap: "16px" }}>
            <Form.Item
              label="Number of Cylinders"
              name="num_cylinders"
              rules={[
                {
                  required: true,
                  message: "Please enter the number of cylinders!",
                },
              ]}
              style={{ flex: 1 }}
            >
              <Input type="number" placeholder="Enter number" />
            </Form.Item>

            <Form.Item
              label="Tank Capacity (Liters)"
              name="tank_capacity"
              rules={[
                { required: true, message: "Please enter the tank capacity!" },
              ]}
              style={{ flex: 1 }}
            >
              <Input type="number" placeholder="Enter number" />
            </Form.Item>
          </div>

          <div style={{ display: "flex", gap: "16px" }}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.fuel_calculation_method !==
                currentValues.fuel_calculation_method
              }
            >
              {({ getFieldValue }) => (
                <Form.Item
                  label={
                    getFieldValue("fuel_calculation_method") === "L_HR"
                      ? "Fuel Consumption (L/Hr)"
                      : "Fuel Efficiency (Km/L)"
                  }
                  name="fuel_utilization"
                  rules={[
                    { required: true, message: "This field is required!" },
                  ]}
                  style={{ flex: 1 }}
                >
                  <Input type="number" step="0.01" placeholder="Enter value" />
                </Form.Item>
              )}
            </Form.Item>

            <Form.Item
              label="Idle Fuel Used/Hr"
              name="fuel_cylinder_hr"
              rules={[
                { required: true, message: "Please enter the fuel usage!" },
              ]}
              style={{ flex: 1 }}
            >
              <Input type="number" step="0.01" placeholder="Enter value" />
            </Form.Item>
          </div>

          <Form.Item
            label="Battery Voltage"
            name="battery_voltage"
            rules={[
              {
                required: true,
                message: "Please select a vehicle's battery voltage!",
              },
            ]}
          >
            <Select placeholder="Select vehicle battery voltage">
              {battery_voltage_list.map((vehicle) => (
                <Option key={vehicle.value} value={vehicle.value}>
                  {vehicle.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            rules={[{ required: true, message: "Please select a fuel type!" }]}
            label="Fuel Type"
            name="fuel_type"
          >
            <Radio.Group>
              <Radio value="regular_diesel">Regular Diesel</Radio>
              <Radio value="low_sulphur_diesel">Low Sulphur Diesel</Radio>
              <Radio value="regular_fuel">Regular Fuel</Radio>
              <Radio value="premium_fuel">Premium Fuel</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        className="vehicle-modal"
        title="Import Vehicles from Excel"
        visible={importModalVisible}
        onCancel={handleImportModalClose}
        footer={[
          <Button key="back" onClick={handleImportModalClose}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={importLoading}
            onClick={handleImportSubmit}
          >
            Import
          </Button>,
        ]}
        width={700}
      >
        <div style={{ marginBottom: 16 }}>
          <Upload
            beforeUpload={beforeUpload}
            fileList={fileList}
            onChange={handleFileChange}
            accept=".xlsx, .xls"
            maxCount={1}
          >
            <Button icon={<UploadOutlined />}>Select Excel File</Button>
          </Upload>
        </div>

        <div style={{ marginTop: 12, marginBottom: 5 }}>
          <Button
            type="link"
            icon={<DownloadOutlined />}
            onClick={handleDownloadTemplate}
          >
            Download Excel Template
          </Button>
        </div>
        <div>
          <div className="modal-title">Excel File Requirements:</div>
          <div className="modal-description ">
            <ul>
              <li>File must be in .xlsx or .xls format</li>
              <li>
                Required columns: vehicle, vehicle_type, num_cylinders,
                tank_capacity, fuel_cylinder_hr, fuel_utilization, fuel_type,
                fuel_calculation_method
              </li>
              <li>vehicle_type should be either "REGULAR" or "STATIONARY"</li>
              <li>
                fuel_type should be one of: regular_diesel, low_sulphur_diesel,
                regular_fuel, premium_fuel
              </li>
              <li>fuel_calculation_method should be either "KM_L" or "L_HR"</li>
              <li>First row should contain headers</li>
            </ul>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Vehicles;
